import { render, staticRenderFns } from "./WorkDate.vue?vue&type=template&id=2489050e&"
import script from "./WorkDate.vue?vue&type=script&lang=js&"
export * from "./WorkDate.vue?vue&type=script&lang=js&"
import style0 from "./WorkDate.vue?vue&type=style&index=0&slot-scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports